import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { Auth, Hub } from "aws-amplify";
import NavSidebar from "../NavBar/NavSidebar/NavSidebar";
import AboutePage from "../About/index";
import TokenRefresher from "../TokenRefresher";

export default function MainPage() {
  const navigate = useNavigate();
  const [isAuthed, setIsAuthed] = useState(false);

  const checkSession = async () => {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: true });
      await Auth.currentSession();
      setIsAuthed(true);
    } catch {
      setIsAuthed(false);
      navigate("/login");
    }
  };

  useEffect(() => {
    checkSession();
    const unsub = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "signIn") checkSession();
      if (payload.event === "signOut") { setIsAuthed(false); navigate("/login"); }
    });
    return () => unsub();
  }, [navigate]);

  if (!isAuthed) return null;

  return (
    <>
      <AboutePage />
      <NavSidebar />
      <main role="main" className="main-content">
        {/* El panel ahora se renderiza en un portal al <body> (TokenRefresher) */}
        <TokenRefresher />

        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
